import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommunityForum = () => {
  const forumTopics = [
    {
      id: 1,
      title: 'Hindu Wedding Traditions - Modern Adaptations',
      author: 'Priya Sharma',
      authorAvatar: 'https://images.unsplash.com/photo-1494790108755-2616b9e3a56f?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&h=150&q=80',
      category: 'Cultural Discussions',
      replies: 23,
      views: 456,
      lastActivity: '2 hours ago',
      isAnswered: true,
      tags: ['Hindu', 'Traditions', 'Modern']
    },
    {
      id: 2,
      title: 'Best Photographers for Punjabi Weddings in Bay Area',
      author: 'Jasdeep Singh',
      authorAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&h=150&q=80',
      category: 'Vendor Recommendations',
      replies: 15,
      views: 289,
      lastActivity: '4 hours ago',
      isAnswered: false,
      tags: ['Photography', 'Punjabi', 'Bay Area']
    },
    {
      id: 3,
      title: 'Mehendi Design Trends 2024',
      author: 'Meera Patel',
      authorAvatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&h=150&q=80',
      category: 'Wedding Planning',
      replies: 31,
      views: 678,
      lastActivity: '1 day ago',
      isAnswered: true,
      tags: ['Mehendi', 'Design', '2024']
    },
    {
      id: 4,
      title: 'Vendor Payment Dispute Resolution',
      author: 'Arjun Krishna',
      authorAvatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&h=150&q=80',
      category: 'Platform Help',
      replies: 8,
      views: 134,
      lastActivity: '3 days ago',
      isAnswered: true,
      tags: ['Payment', 'Dispute', 'Resolution']
    },
    {
      id: 5,
      title: 'South Indian Wedding Menu Planning',
      author: 'Lakshmi Nair',
      authorAvatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&h=150&q=80',
      category: 'Cultural Discussions',
      replies: 19,
      views: 342,
      lastActivity: '5 days ago',
      isAnswered: false,
      tags: ['South Indian', 'Menu', 'Planning']
    }
  ];

  const forumCategories = [
    {
      name: 'Cultural Discussions',
      count: 142,
      color: 'primary'
    },
    {
      name: 'Vendor Recommendations',
      count: 89,
      color: 'secondary'
    },
    {
      name: 'Wedding Planning',
      count: 67,
      color: 'success'
    },
    {
      name: 'Platform Help',
      count: 34,
      color: 'warning'
    }
  ];

  const getCategoryColor = (category) => {
    const colorMap = {
      'Cultural Discussions': 'bg-primary-100 text-primary',
      'Vendor Recommendations': 'bg-secondary-100 text-secondary',
      'Wedding Planning': 'bg-success-100 text-success',
      'Platform Help': 'bg-warning-100 text-warning'
    };
    return colorMap[category] || 'bg-surface-100 text-text-secondary';
  };

  const formatTimeAgo = (timeString) => {
    return timeString;
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl text-text-primary mb-4">
            Community Forum
          </h2>
          <p className="text-lg text-text-secondary">
            Ask questions, share experiences, and connect with other couples and vendors
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Forum Categories Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-surface-50 rounded-xl p-6 sticky top-24">
              <h3 className="font-heading font-semibold text-lg text-text-primary mb-4">
                Categories
              </h3>
              <div className="space-y-3">
                {forumCategories?.map((category, index) => (
                  <button
                    key={index}
                    className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-white transition-colors"
                  >
                    <span className="text-text-secondary">{category?.name}</span>
                    <span className="text-text-muted text-sm">{category?.count}</span>
                  </button>
                ))}
              </div>
              
              <div className="mt-6 pt-6 border-t border-border">
                <Button
                  variant="primary"
                  size="sm"
                  iconName="Plus"
                  fullWidth
                  onClick={() => console.log('Create new topic')}
                >
                  New Topic
                </Button>
              </div>
            </div>
          </div>
          
          {/* Forum Topics */}
          <div className="lg:col-span-3">
            <div className="space-y-4">
              {forumTopics?.map((topic) => (
                <div
                  key={topic?.id}
                  className="bg-white border border-border rounded-xl p-6 hover:shadow-soft transition-shadow cursor-pointer"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <img
                        src={topic?.authorAvatar}
                        alt={topic?.author}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="font-medium text-text-primary">{topic?.author}</p>
                        <p className="text-text-muted text-sm">{formatTimeAgo(topic?.lastActivity)}</p>
                      </div>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryColor(topic?.category)}`}>
                        {topic?.category}
                      </span>
                      {topic?.isAnswered && (
                        <div className="flex items-center space-x-1 text-success">
                          <Icon name="CheckCircle" size={14} />
                          <span className="text-xs">Answered</span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <h3 className="font-heading font-semibold text-lg text-text-primary mb-3 hover:text-primary transition-colors">
                    {topic?.title}
                  </h3>
                  
                  <div className="flex items-center space-x-2 mb-4">
                    {topic?.tags?.map((tag, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-surface-100 text-text-muted text-xs rounded-full"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 text-text-muted text-sm">
                      <div className="flex items-center space-x-1">
                        <Icon name="MessageCircle" size={14} />
                        <span>{topic?.replies} replies</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Eye" size={14} />
                        <span>{topic?.views} views</span>
                      </div>
                    </div>
                    
                    <button className="text-primary hover:text-primary-600 text-sm font-medium transition-colors">
                      View Discussion →
                    </button>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <Button
                variant="outline"
                size="lg"
                iconName="MoreHorizontal"
                onClick={() => console.log('Load more topics')}
              >
                Load More Topics
              </Button>
            </div>
          </div>
        </div>
        
        {/* Community Stats */}
        <div className="mt-16 pt-12 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">1,247</div>
              <div className="text-text-secondary">Active Members</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-secondary mb-2">342</div>
              <div className="text-text-secondary">Discussion Topics</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-success mb-2">2,156</div>
              <div className="text-text-secondary">Total Posts</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-warning mb-2">89%</div>
              <div className="text-text-secondary">Questions Answered</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityForum;